export const HARM_TYPES = [
  { value: "credit_damage", label: "Credit Damage / FCRA Violation" },
  { value: "wrongful_billing", label: "Wrongful Billing / Overcharge" },
  { value: "housing_denial", label: "Housing Denial / Rental Discrimination" },
  { value: "service_shutoff", label: "Service Shutoff / Lockout" },
  { value: "debt_harassment", label: "Debt Collector Harassment / FDCPA" },
  { value: "data_breach", label: "Data Breach / Privacy Violation" },
  { value: "fraud", label: "Fraud / Deceptive Practices" },
  { value: "discrimination", label: "Discrimination" },
  { value: "warranty_refusal", label: "Warranty / Refund Refusal" },
  { value: "other", label: "Other Corporate Harm" },
];

export const DRAFT_TARGETS = [
  { value: "demand_letter", label: "Demand Letter", short: "DEMAND", desc: "Direct legal demand to the corporation" },
  { value: "cfpb", label: "CFPB Complaint", short: "CFPB", desc: "Consumer Financial Protection Bureau" },
  { value: "ftc", label: "FTC Complaint", short: "FTC", desc: "Federal Trade Commission" },
  { value: "state_ag", label: "State AG Complaint", short: "STATE AG", desc: "State Attorney General Consumer Division" },
  { value: "bbb", label: "BBB Complaint", short: "BBB", desc: "Better Business Bureau" },
  { value: "executive", label: "Executive Escalation", short: "EXEC", desc: "CEO / General Counsel escalation letter" },
];

export const harmLabel = (v) => HARM_TYPES.find((h) => h.value === v)?.label || v;
export const targetLabel = (v) => DRAFT_TARGETS.find((t) => t.value === v)?.label || v;
